import { Action } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { ColumnLayout } from "@mittwald/flow-remote-react-components";
import { TextField } from "@mittwald/flow-remote-react-components";
import { Label } from "@mittwald/flow-remote-react-components";
import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Form,
  typedField,
} from "@mittwald/flow-remote-react-components/react-hook-form";
import { useEffect, useState } from "react";
import { CreateUserError } from "../../errors/CreateUserError";
import { OverlayController } from "@mittwald/flow-remote-react-components";
import { useChangeUserPassword } from "../../hooks/useChangeUserPassword";

interface FormInputs {
  password: string;
}

export const ChangePasswordModal = (props: {
  projectId: string;
  username: string;
  controller: OverlayController;
}) => {
  const [errorOnSubmit, setErrorOnSubmit] = useState<Error | undefined>(
    undefined,
  );

  if (errorOnSubmit) {
    throw errorOnSubmit;
  }

  const { controller } = props;

  const form = useForm<FormInputs>({
    defaultValues: {
      password: "",
    },
  });

  // Registered in an effect so the handler is added once and removed on
  // unmount (addOnClose returns the disposer).
  useEffect(
    () =>
      controller.addOnClose(() => {
        form.reset();
      }),
    [controller, form],
  );

  const changePasswordMutation = useChangeUserPassword(props.projectId);

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    const result = await changePasswordMutation.mutateAsync({
      username: props.username,
      password: data.password,
    });

    if (result.error) {
      setErrorOnSubmit(new CreateUserError(result.error.message));
    }

    controller.close();
  };

  const Field = typedField(form);

  return (
    <Modal controller={controller} size="s">
      <Form form={form} onSubmit={onSubmit}>
        <Heading>
          <Text>Passwort ändern</Text>
        </Heading>
        <Content>
          <Section>
            <Text>
              Diese Aktion aktualisiert das Passwort des Benutzers in allen
              Passwortschutzen, denen er zugeordnet ist.
            </Text>

            <ColumnLayout m={[1, 1]}>
              <Field
                name={"password"}
                rules={{
                  required: "Bitte gib das neue Passwort ein",
                }}
              >
                <TextField type="password" isRequired autoFocus>
                  <Label>Passwort</Label>
                </TextField>
              </Field>
            </ColumnLayout>
          </Section>
        </Content>
        <ActionGroup>
          <Button
            color="success"
            type="submit"
            isPending={changePasswordMutation.isPending}
            isSucceeded={changePasswordMutation.isSuccess}
          >
            Passwort ändern
          </Button>
          <Action
            onAction={() => {
              controller.close();
            }}
          >
            <Button color="secondary" variant="soft">
              Abbrechen
            </Button>
          </Action>
        </ActionGroup>
      </Form>
    </Modal>
  );
};
